import { createResponseTransformer } from "shared/api/createResponseTransformer"

export const productInformationResponseTransformer = createResponseTransformer(
  json => json
)
